module.exports = "data:image/webp;base64,UklGRuAAAABXRUJQVlA4INQAAACQCQCdASqQAFQAPm00mUmkIqKiIdVYUIANiWkvlUreumG2qZxd28AlJuArWvD0o62zK/jJoCMr3uSVPTKNOWav7xkGmbmrQXhl75a0U9yBZSVxXjSAAP753JdpAtJieJ6jPsspX0sVzG2bHGMpjoF0xxq2mvslgTX0kgCbR7e5hLKjwJGCA6NMd7I7Mv0giSXUufebTYTlcPlPH6evuHA6zzQ2F0gAK1WXtgHyt86iGCZkEpoeALcfVAh06AMXu7ObxaoQamsR/125W0G1IJxZUwAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/label-bg.webp
// module id = NOSN
// module chunks = 3